// Ported from dev-scrips-pm-react src/shared/store/create-appointment-handoff.ts (PROD-1119 cross-module closure).
import { create } from 'zustand';
import type { AppointmentFormValues } from '@/types/appointment-form';

/**
 * Cross-domain handoff for "Create Appointment" launched OUTSIDE the
 * scheduling module (e.g. the patient-list row kebab). Lives in `shared/`
 * because `patients/` may not import `scheduling/` and vice-versa
 * (CLAUDE.md structural rule) — both, plus the app shell, import this.
 *
 * Flow (product decision 2026-06-02 — overlay, NOT a nav switch):
 *   1. Patient-list kebab → `requestCreateAppointment(prefill)`.
 *   2. `App.tsx` watches `pendingPrefill`; when set, it renders the calendar's
 *      `CreateAppointmentPanel` as an OVERLAY over the current surface — the
 *      user is NOT taken to the Calendar. Booking shows its own toast and
 *      calls onClose → `clear()`, dismissing the overlay in place.
 *
 * The payload is a generic `Partial<AppointmentFormValues>` — the
 * patient→form mapping is built in `patients/` (which owns PatientDatum);
 * scheduling only receives form values, so neither domain imports the other.
 */
interface CreateAppointmentHandoffState {
  pendingPrefill: Partial<AppointmentFormValues> | null;
  requestCreateAppointment: (prefill: Partial<AppointmentFormValues>) => void;
  clear: () => void;
}

export const useCreateAppointmentHandoff =
  create<CreateAppointmentHandoffState>((set) => ({
    pendingPrefill: null,
    requestCreateAppointment: (prefill) => set({ pendingPrefill: prefill }),
    clear: () => set({ pendingPrefill: null }),
  }));
